import { defineComponent as _defineComponent } from 'vue'
import { BKCheckinButton } from '@/features/checkin'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { getDateRangeFormatted, getTimeRangeFormatted } from '@/services/date'
import {
  mdiCalendarCheck,
  mdiCheckCircle,
  mdiChevronDown,
  mdiChevronUp,
  mdiClockOutline,
  mdiCurrencyUsd,
  mdiLink,
  mdiMapMarkerRadius,
  mdiPencilOutline,
} from '@mdi/js'
import { EventDB } from '@/enitites/event'
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router/composables'
import { useVuetify } from '@/services/useVuetify'
import EventFeedbackBlock from './EventFeedbackBlock.vue'
import EventFeedbackBlockAdmin from './EventFeedbackBlockAdmin.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventSidebar',
  props: {
    event: null
  },
  emits: ["update:event", "reload:event"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:event', updatedEvent: EventDB): void
  (e: 'reload:event'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  event: EventDB
};

const DisplayModeModal = () => import('@/enitites/display-mode/components/DisplayModeModal.vue')

const vuetify = useVuetify()
const isTabletDesktop = computed(() => vuetify.breakpoint.mdAndUp)




const router = useRouter()

const isCollapsed = ref(true)
const date = computed(() => getDateRangeFormatted(props.event.dateStart, props.event.dateEnd, false))
const time = computed(() => getTimeRangeFormatted(props.event.dateStart, props.event.dateEnd))
const totalTierCost = computed(() => {
  if (!props.event.tiers.length) return 'Free'
  const costs = props.event.tiers.map((tier) => tier.cost)
  const min = Math.min(...costs)
  const max = Math.max(...costs)
  if (min === Infinity || max === Infinity) return ' '
  if (max === 0) {
    return 'Free'
  }
  if (min === max) return `$${max}`

  return `$${min} - $${max}`
})

function editEvent() {
  router.push({ name: 'CreateEventProcessing', params: { id: String(props.event.id) } })
}

function handleMobileInfoToggle() {
  isCollapsed.value = !isCollapsed.value
}

return { __sfc: true,DisplayModeModal, vuetify, isTabletDesktop, props, emit, router, isCollapsed, date, time, totalTierCost, editEvent, handleMobileInfoToggle, BKCheckinButton, mdiCalendarCheck, mdiCheckCircle, mdiChevronDown, mdiChevronUp, mdiClockOutline, mdiCurrencyUsd, mdiLink, mdiMapMarkerRadius, mdiPencilOutline, EventFeedbackBlock, EventFeedbackBlockAdmin }
}

})